import { AuditLogState } from './types'

export const state: AuditLogState = {
  auditLogEntries: [],
}
